import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { FeedState, FeedStore } from './feed.store';

@Injectable({ providedIn: 'root' })
export class FeedQuery extends QueryEntity<FeedState> {
  constructor(protected store: FeedStore) {
    super(store);
  }

  readonly feeds$ = this.select((state) => state.feeds);
  readonly dynamicLoyaltyFeeds$ = this.select((state) => state.dynamicLoyaltyFeeds);
  readonly pageNumber$ = this.select((state) => state.pageNumber);
  readonly loading$ = this.selectLoading();

  getPageNumber(): number {
    return this.getValue().pageNumber;
  }
}
